import { useState } from "react";
import {
  ChevronDown,
  ChevronUp,
  Shield,
  Globe,
  BookOpen,
  AlertCircle,
  Users,
  Bell,
  Clock,
  FileText,
} from "lucide-react";

export default function PrivacyPolicy() {
  const [expandedSection, setExpandedSection] = useState(null);

  const toggleSection = (index) => {
    if (expandedSection === index) {
      setExpandedSection(null);
    } else {
      setExpandedSection(index);
    }
  };

  const sections = [
    {
      title: "Introducción",
      icon: <Shield className="text-blue-600" />,
      content:
        "En DeportivosPro, valoramos tu confianza y respetamos tu privacidad. Esta política explica cómo recopilamos, utilizamos y protegemos tus datos personales cuando utilizas nuestra aplicación de pronósticos deportivos.",
    },
    {
      title: "Datos que Recopilamos",
      icon: <FileText className="text-blue-600" />,
      content:
        "Recopilamos información como tu nombre, correo electrónico, preferencias deportivas y comportamiento de uso en la aplicación para ofrecerte una experiencia personalizada y mejorar nuestros servicios.",
    },
    {
      title: "Uso de la Información",
      icon: <Users className="text-blue-600" />,
      content:
        "Utilizamos tus datos para personalizar tu experiencia, enviar pronósticos deportivos relevantes, procesar transacciones, mejorar nuestros servicios y comunicarnos contigo sobre actualizaciones o promociones.",
    },
    {
      title: "Compartiendo Información",
      icon: <Globe className="text-blue-600" />,
      content:
        "No vendemos tus datos personales. Compartimos información con proveedores de servicios de confianza que nos ayudan a operar la aplicación y con autoridades cuando sea requerido por ley.",
    },
    {
      title: "Cookies y Tecnologías Similares",
      icon: <BookOpen className="text-blue-600" />,
      content:
        "Utilizamos cookies y tecnologías similares para mejorar tu experiencia, analizar el uso de la aplicación y personalizar contenido. Puedes gestionar tus preferencias de cookies a través de la configuración de tu dispositivo.",
    },
    {
      title: "Seguridad",
      icon: <AlertCircle className="text-blue-600" />,
      content:
        "Implementamos medidas de seguridad para proteger tus datos contra acceso no autorizado, alteración o divulgación. Sin embargo, ninguna transmisión por internet es completamente segura.",
    },
    {
      title: "Notificaciones",
      icon: <Bell className="text-blue-600" />,
      content:
        "Puedes recibir notificaciones sobre pronósticos, resultados y promociones. Puedes configurar tus preferencias de notificaciones en cualquier momento dentro de la aplicación.",
    },
    {
      title: "Actualizaciones de la Política",
      icon: <Clock className="text-blue-600" />,
      content:
        "Podemos actualizar esta política ocasionalmente. Te notificaremos sobre cambios significativos a través de la aplicación o por correo electrónico.",
    },
  ];

  return (
    <div className="bg-gray-900 min-h-screen p-2">
      <div className="max-w-3xl mx-auto bg-white rounded-lg shadow-lg overflow-hidden">
        <div className="bg-blue-600 p-6 text-white">
          <h1 className="text-2xl font-bold mb-2">Política de Privacidad</h1>
          <p className="text-blue-100">
            DeportivosPro - Tu app de pronósticos deportivos
          </p>
        </div>

        <div className="p-6">
          <p className="text-gray-600 mb-6">Última actualización: Mayo 2025</p>

          <div className="space-y-4 text-black">
            {sections.map((section, index) => (
              <div
                key={index}
                className="border border-gray-200 rounded-lg overflow-hidden"
              >
                <button
                  className="flex items-center justify-between w-full p-4 text-left bg-gray-50 hover:bg-gray-100 transition-colors"
                  onClick={() => toggleSection(index)}
                >
                  <div className="flex items-center space-x-3">
                    {section.icon}
                    <span className="font-medium">{section.title}</span>
                  </div>
                  {expandedSection === index ? (
                    <ChevronUp className="text-gray-500" />
                  ) : (
                    <ChevronDown className="text-gray-500" />
                  )}
                </button>

                {expandedSection === index && (
                  <div className="p-4 bg-white">
                    <p className="text-gray-700">{section.content}</p>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="mt-8 text-center">
            <p className="text-gray-500 text-sm">
              Si tienes preguntas sobre nuestra política de privacidad,
              contáctanos en:
              <a
                href="mailto:soporte@deportivospro.online"
                className="text-blue-600 ml-1 hover:underline"
              >
                soporte@deportivospro.online
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
